import '../../styles-new/pages/olympiad/team-ukraine.scss';
import EmblaCarousel from 'embla-carousel';
import { countdownBar } from '../components/olympiad/countdown-bar';

const initLoadMore = (sectionSelector, opts = {}) => {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const loadMoreBtn = section.querySelector('.load-more');
  const listContainer = section.querySelector(opts.listSelector || '.athletes');

  if (!loadMoreBtn || !listContainer) return;

  const setLoading = (state) => {
    loadMoreBtn.disabled = state;
    loadMoreBtn.dataset.loading = state ? '1' : '0';
  };

  const hideButton = () => {
    loadMoreBtn.style.display = 'none';
  };

  loadMoreBtn.addEventListener('click', async () => {
    if (loadMoreBtn.dataset.loading === '1') return;
    setLoading(true);

    const baseUrl = loadMoreBtn.dataset.url;
    const offset = parseInt(loadMoreBtn.dataset.offset || '0', 10);
    const limit = parseInt(loadMoreBtn.dataset.limit || '0', 10) || 8;
    const sport = loadMoreBtn.dataset.sport || '';

    try {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('offset', offset);
      url.searchParams.set('limit', limit);
      if (sport) url.searchParams.set('sport', sport);

      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Failed to load items');

      const data = await response.json();
      if (data.html) {
        listContainer.insertAdjacentHTML('beforeend', data.html);
      }

      loadMoreBtn.dataset.offset = data.next_offset ?? offset + limit;

      if (!data.has_more) {
        hideButton();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  countdownBar();
  initLoadMore('.team-ukraine-athletes', { listSelector: '.athletes' });
  initLoadMore('.team-ukraine-trainers', { listSelector: '.team-ukraine-trainers__container' });
});
const initEmbla = () => {
  const OPTIONS = { 
    align: 'start', 
    loop: true, 
    watchDrag: false,
    loop: false,
    breakpoints: {
      '(max-width: 1024px)': { 
        loop: true,
        watchDrag: true,
      }
    }
  };

  const emblaNode = document.querySelector('.team-ukraine-embla');
  const viewportNode = emblaNode.querySelector('.team-ukraine-embla__viewport');
  const prevBtnNode = emblaNode.querySelector('.team-ukraine-embla__button--prev');
  const nextBtnNode = emblaNode.querySelector('.team-ukraine-embla__button--next');
  const descriptionNodes = emblaNode.querySelectorAll('.team-ukraine__slide_description');
  const slides = emblaNode.querySelectorAll('.team-ukraine__slide_wrapper');
  let activeSlide = 0;

  const mq = window.matchMedia('(max-width: 1024px)');
  const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

  const handleChangeSlideDesktop = (slide, idx) => {
    const hasNext = idx + 1 < slides.length;
    const hasPrev = idx > 0;

    if(hasNext) {
      nextBtnNode.removeAttribute('disabled');
    } else {
      nextBtnNode.setAttribute('disabled', 'true');
    }

    if(hasPrev) {
      prevBtnNode.removeAttribute('disabled');
    } else {
      prevBtnNode.setAttribute('disabled', 'true');
    }

    activeSlide = idx;

    slides.forEach((item) => {
      item.classList.add('team-ukraine__slide_wrapper_closed');
    });
    slide.classList.remove('team-ukraine__slide_wrapper_closed');
    setTimeout(() => {
      emblaApi.scrollTo(idx);
    }, 800);
  }

  const handleContainerClick = (e) => {
    const slide = e.target.closest('.team-ukraine__slide_wrapper');

    if(!slide) {
      return
    }

    const idx = [...slides].indexOf(slide);

    handleChangeSlideDesktop(slide, idx);
  }

  const handleDesktopNextBtnClick = () => {
    handleChangeSlideDesktop(slides[activeSlide + 1], activeSlide + 1);
  }

  const handleDesktopPrevBtnClick = () => {
    handleChangeSlideDesktop(slides[activeSlide - 1], activeSlide - 1);
  }

  const handleReadMore = (e) => {
    if(e.target.tagName === 'BUTTON') {
      descriptionNodes.forEach((item) => {
        item.classList.add('team-ukraine__slide_description_open');
        item.querySelector('.team-ukraine__slide_read_more').classList.add('hidden');
      })
    }
  }

  descriptionNodes.forEach(item => {
    item.addEventListener('click', handleReadMore)
  })

  const mqHandler = () => {
    const isMobile = mq.matches;

    if(!isMobile) {
      viewportNode.addEventListener('click', handleContainerClick);
      prevBtnNode.setAttribute('disabled', 'true');
      prevBtnNode.removeEventListener('click', emblaApi.scrollPrev, false)
      nextBtnNode.removeEventListener('click', emblaApi.scrollNext, false)
      nextBtnNode.addEventListener('click', handleDesktopNextBtnClick);
      prevBtnNode.addEventListener('click', handleDesktopPrevBtnClick);
    } else {
      viewportNode.removeEventListener('click', handleContainerClick);
      prevBtnNode.removeAttribute('disabled');
      nextBtnNode.removeAttribute('disabled');
      nextBtnNode.removeEventListener('click', handleDesktopNextBtnClick);
      prevBtnNode.removeEventListener('click', handleDesktopPrevBtnClick);
      prevBtnNode.addEventListener('click', emblaApi.scrollPrev, false)
      nextBtnNode.addEventListener('click', emblaApi.scrollNext, false)
    }
  };

  mqHandler();

  mq.addEventListener('change', mqHandler);
}

const tabsHandler = () => {
  const tabsContainer = document.querySelector('.team-ukraine-athletes__tabs');
  const tabs = tabsContainer.querySelectorAll('button');

  tabsContainer.addEventListener('click', (e) => {
    const tab = e.target.closest('.team-ukraine-athletes__tabs_item');

    if(!tab) {
      return
    }

    tabs.forEach(item => {
      item.classList.remove('tabs__item_active');
    });

    tab.classList.add('tabs__item_active');
  })
}

window.addEventListener('DOMContentLoaded', () => {
  countdownBar();
  initEmbla();
  tabsHandler();
});
